export default __webpack_public_path__ + "815d326a0f05daff29d2af0ba949708d.png";